<template>
  <form :id="'frm-'+id"
        class="px-3"
        method="post"
        onsubmit="return false">
    <div :id="id"
         :aria-labelledby="id+'-title'"
         :data-id="name"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header mb-2">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body">
            <div class="container">
              
              <div class="form-group">
                <label class="font-weight-normal"
                       for="funder">Financiadora:</label>
                <select id="funder"
                        v-model="commitment.funder_id"
                        class="form-control"
                        name="funder">
                  <option value="">Seleccione una financiadora</option>
                  <option v-for="(funder, key) in funders"
                          :key="key"
                          :value="funder.pivot_funder_id ? funder.pivot_funder_id : funder.pivot.id">{{ funder.title }}
                  </option>
                </select>
              </div>
              
              <div class="form-group">
                <label class="font-weight-normal"
                       for="description">Compromiso contraído:</label>
                <input id="description"
                       v-model="commitment.commitment_made"
                       class="form-control"
                       name="description"
                       placeholder="Descripción del compromiso contraído"
                       type="text">
              </div>
              
              <div class="form-group">
                <label class="font-weight-normal"
                       for="date">Fecha de cumplimiento:</label>
                <input id="date"
                       v-model="commitment.compliance_date"
                       class="form-control"
                       name="date"
                       placeholder="DD/MM/AAAA"
                       type="date">
              </div>
            </div>
          </div>
          
          <div class="modal-footer flex px-2 shadow-none modal-body-scrolled">
            <button :disabled="addingCommitment"
                    class="btn btn-primary mr-2"
                    type="submit">
              <template v-if="!addingCommitment">
                {{ commitment.id ? 'Editar':  'Agregar' }}
              </template>
              <span v-if="addingCommitment"
                    class="spinner-border text-yellow-500 spinner-border-sm"
                    role="status">
                <span class="sr-only">
                  {{ commitment.id ? 'Editando':  'Agregando' }}...
                </span>
              </span>
            </button>
            
            <button class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                    :disabled="addingCommitment"
                    @click="clearForm">Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import 'jquery-validation'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  
  export default {
    name: 'FinancingCommitmentModal',
    components: {},
    props: {
      title: {
        default: 'Registro de compromiso',
      },
      id: {
        default: 'financing-commitments-modal',
      },
      name: {
        default: 'financing-commitment-modal',
      },
      type: {
        type: String,
        default: 'protocol',
      },
      funders: {
        type: Array,
        default: [],
      },
      selectedCommitment: {
        type: Object,
        default: null,
      },
      addCommitmentFunction: {
        type: Function,
        default: null,
      },
      editCommitmentFunction: {
        type: Function,
        default: null,
      },
    },
    data () {
      return {
        commitment: {
          id: null,
          funder_id: '',
          commitment_made: '',
          compliance_date: '',
          type: this.type,
        },
        addingCommitment: false,
      }
    },
    methods: {
      clearForm () {
        this.commitment.id = null
        this.commitment.funder_id = ''
        this.commitment.commitment_made    = ''
        this.commitment.compliance_date    = ''
      },
      async addCommitment () {
        this.addingCommitment = true
        
        if (!this.commitment.id && this.addCommitmentFunction) {
          this.addCommitmentFunction(this.commitment, () => {
            this.clearForm()
            this.addingCommitment = false
          })
        }

        if (this.commitment.id && this.editCommitmentFunction) {
          this.editCommitmentFunction(this.commitment, () => {
            this.clearForm()
            this.addingCommitment = false
          })
        }
      },
    },
    watch: {
      selectedCommitment: function(commitment) {
        this.commitment.id = commitment.id
        this.commitment.funder_id = commitment.funder_id
        this.commitment.commitment_made = commitment.commitment_made
        this.commitment.compliance_date = commitment.compliance_date
      }
    },
    mounted () {
      const vm = this
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $('#date').flatpickr({
          disableMobile: false,
          dateFormat: 'd/m/Y',
          locale: Spanish,
        })
        
        $('#frm-financing-commitments-modal').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if (element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            funder: {
              required: true,
            },
            description: {
              required: true,
            },
            date: {
              required: true,
            },
          },
          messages: {
            funder: {
              required: 'Este campo es requerido.',
            },
            description: {
              required: 'Este campo es requerido.',
            },
            date: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            vm.addCommitment()
          },
        })
      })
    },
  }
</script>
